import Link from 'next/link';
import { useRouter } from 'next/router';

const ShowsNavigation = () => {
	const router = useRouter();

	// determine the current page
	const isFeaturedShowsPage = `${router.pathname === '/shows' ? 'current' : ''}`;
	const isAllShowsPage = `${router.pathname === '/all-shows' ? 'current' : ''}`;

	const buttonClass = 'shows-navigation-button';

	return (
		<div className="shows-navigation">
			<div className="shows-navigation-container">
				<Link
					href="/shows/"
					aria-label="View featured shows"
					className={`${buttonClass} ${isFeaturedShowsPage}`}
				>

					Featured

				</Link>
				<Link
					href="/all-shows/"
					aria-label="View all shows"
					className={`${buttonClass} ${isAllShowsPage}`}
				>

					All

				</Link>
			</div>
			<div className="shows-navigation-separator">&nbsp;</div>
		</div>
	);
};

export default ShowsNavigation;
